import { transparentize } from 'polished';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { colors } from '@keen.io/colors';
import { BodyText } from '@keen.io/typography';
import { NoComponentSettingsWrapper } from './ComponentSettingsNotAvailable.styles';

var ComponentSettingsNotAvailable = function ComponentSettingsNotAvailable(_ref) {
  var widgetType = _ref.widgetType;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return React.createElement(NoComponentSettingsWrapper, null, React.createElement(BodyText, {
    variant: "body1",
    color: transparentize(0.5, colors.black[100])
  }, widgetType ? t('widget_customization.chart_settings_not_available_for_widget', {
    widget: widgetType
  }) : t('widget_customization.chart_settings_not_available')));
};

export default ComponentSettingsNotAvailable;